<div class="flex-container">
  <button
    sdButton
    size="s"
    [fullWidth]="isTabletDown() ?? false"
    [theme]="orderListType() === orderListTypes.Online ? 'primary' : 'secondary'"
    (click)="setOrderListType(orderListTypes.Online)"
  >
    интернет-заказ
  </button>
  <button
    sdButton
    size="s"
    [fullWidth]="isTabletDown() ?? false"
    [theme]="orderListType() === orderListTypes.Offline ? 'primary' : 'secondary'"
    (click)="setOrderListType(orderListTypes.Offline)"
  >
    покупка в магазине
  </button>
</div>
